// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"2b445d0f","344":"828273f6","399":"06747876","623":"24d09b92","681":"1b5494e7","861":"fcaf9bb9","964":"1b5494e7"}[chunkId] + ".chunk.css";
};